import React from 'react'
import { IconComponent } from '~/assets/icons/component'
import { SpinnerIconLoader } from '~/components/shared'

export const Loader = (): JSX.Element => (
  <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
)
